import { toast } from 'react-toastify'

const fallbackCopyTextToClipboard = (text: string, toastMessage: string) => {
    const textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        const successful = document.execCommand('copy')
        successful && toast.success(toastMessage)
    } catch (err) {
        console.error('Could not copied specified text:', err)
    }

    document.body.removeChild(textArea)
}

export const copyTextToClipboard = (text: string, toastMessage: string) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, toastMessage)
        return
    }
    navigator.clipboard.writeText(text).then(() => toast.success(toastMessage))
}

export const handleShare = (data: ShareData, fallback: () => void, onSuccess: () => void) => {
    if (navigator?.canShare && navigator?.share && navigator?.canShare(data)) {
        navigator
            .share(data)
            .then(() => onSuccess())
            .catch((error) => {
                console.error('Cannot use share function', error)
            })
    } else {
        fallback()
    }
}
